export const AUTH_TOKEN_LOCAL_STORAGE_KEY = 'AUTH_TOKEN';
export const AUTH_TYPE_LOCAL_STORAGE_KEY = 'AUTH_TYPE';